import { Button, Modal, Select, message } from "antd";
import React, { useState } from "react";
import {SimulatorPersonIdPair, SUSPENSION_REASON_LABELS} from "../../model/models";
import { HttpService } from "../../services/http/Http.service";
import { HttpErrorService } from "../../services/http/HttpError.service";

interface SuspendProps {
    selectedSimulatorPersonPairs: SimulatorPersonIdPair[];
    onSuccess: () => void;
    reason?: string;
}

export default function Suspend({ selectedSimulatorPersonPairs, onSuccess, reason }: SuspendProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReason, setSelectedReason] = useState<string | undefined>(undefined);

    const suspendReasonOptions = [
        { value: "SCADUTA_ISTRUTTORIA", label: "Scaduta istruttoria" },
        { value: "SCADUTA_DECESSO", label: "Scaduta decesso" },
    ];

    const reasonKey = Object.keys(SUSPENSION_REASON_LABELS).find(key => SUSPENSION_REASON_LABELS[key] === reason);

    const handleConfirm = async () => {
        const effectiveReason = reasonKey ?? selectedReason;

        if (!effectiveReason) {
            message.warning("Seleziona un motivo.");
            return;
        }

        try {
            await HttpService.getInstanceAxios().post(
                "/alert/non-payment/suspend",
                selectedSimulatorPersonPairs,
                { params: { reason: effectiveReason } }
            );
            message.success("Pratiche sospese con successo");
            setIsModalOpen(false);
            onSuccess();
        } catch (error) {
            HttpErrorService.handle("Errore durante la sospensione", error, true);
        }
    };

    const openModal = () => {
        if (selectedSimulatorPersonPairs.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error("Nessun utente selezionato.");
        }
    };

    return (
        <>
            <Button
                className="custom-label-color"
                onClick={openModal}
                size="large"
                disabled={selectedSimulatorPersonPairs.length === 0}
                type="primary"
            >
                Sospendi
            </Button>

            <Modal
                title="Sospendi"
                open={isModalOpen}
                onOk={handleConfirm}
                okText="Sì, sospendi"
                onCancel={() => setIsModalOpen(false)}
                cancelText="Annulla"
            >
                {reason ? (
                    <p>{"Sei sicuro di voler sospendere per " + reason + "?"}</p>
                ) : (
                    <>
                        <p>Per quale motivo vuoi sospendere la/le pratica/e?</p>
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Seleziona motivo"
                            options={suspendReasonOptions}
                            value={selectedReason}
                            onChange={setSelectedReason}
                        />
                    </>
                )}
            </Modal>
        </>
    );
}
